/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

//menus para el admin
export const defaultNavigation_admin: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: 'Panel general de la plataforma',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/admin/home'
    },
    {
        id      : 'clientes',
        title   : 'Clientes',
        subtitle: 'Cuentas cliente y estado general',
        type    : 'basic',
        icon    : 'heroicons_outline:building-office-2',
        link    : '/admin/clientes'
    },
    {
        id      : 'usuarios',
        title   : 'Usuarios',
        subtitle: 'Accesos y administración global',
        type    : 'basic',
        icon    : 'heroicons_outline:users',
        link    : '/admin/usuarios'
    },
    {
        id      : 'timbres',
        title   : 'Timbres',
        subtitle: 'Saldo, consumo y control operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:ticket',
        link    : '/admin/timbres'
    },
    {
        id      : 'movimientos',
        title   : 'Movimientos',
        subtitle: 'Recargas, ajustes y bitácora',
        type    : 'basic',
        icon    : 'heroicons_outline:arrows-right-left',
        link    : '/admin/movimientos'
    },
    {
        id      : 'soporte',
        title   : 'Soporte',
        subtitle: 'Seguimiento y apoyo operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:lifebuoy',
        link    : '/admin/soporte'
    },
    {
        id      : 'configuracion',
        title   : 'Configuración',
        subtitle: 'Parámetros generales de la herramienta',
        type    : 'basic',
        icon    : 'heroicons_outline:cog-6-tooth',
        link    : '/admin/configuracion'
    }
];

export const compactNavigation_admin: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: 'Panel general de la plataforma',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/admin/home'
    },
    {
        id      : 'clientes',
        title   : 'Clientes',
        subtitle: 'Cuentas cliente y estado general',
        type    : 'basic',
        icon    : 'heroicons_outline:building-office-2',
        link    : '/admin/clientes'
    },
    {
        id      : 'usuarios',
        title   : 'Usuarios',
        subtitle: 'Accesos y administración global',
        type    : 'basic',
        icon    : 'heroicons_outline:users',
        link    : '/admin/usuarios'
    },
    {
        id      : 'timbres',
        title   : 'Timbres',
        subtitle: 'Saldo, consumo y control operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:ticket',
        link    : '/admin/timbres'
    },
    {
        id      : 'movimientos',
        title   : 'Movimientos',
        subtitle: 'Recargas, ajustes y bitácora',
        type    : 'basic',
        icon    : 'heroicons_outline:arrows-right-left',
        link    : '/admin/movimientos'
    },
    {
        id      : 'soporte',
        title   : 'Soporte',
        subtitle: 'Seguimiento y apoyo operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:lifebuoy',
        link    : '/admin/soporte'
    },
    {
        id      : 'configuracion',
        title   : 'Configuración',
        subtitle: 'Parámetros generales de la herramienta',
        type    : 'basic',
        icon    : 'heroicons_outline:cog-6-tooth',
        link    : '/admin/configuracion'
    }
];

export const futuristicNavigation_admin: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: 'Panel general de la plataforma',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/admin/home'
    },
    {
        id      : 'clientes',
        title   : 'Clientes',
        subtitle: 'Cuentas cliente y estado general',
        type    : 'basic',
        icon    : 'heroicons_outline:building-office-2',
        link    : '/admin/clientes'
    },
    {
        id      : 'usuarios',
        title   : 'Usuarios',
        subtitle: 'Accesos y administración global',
        type    : 'basic',
        icon    : 'heroicons_outline:users',
        link    : '/admin/usuarios'
    },
    {
        id      : 'timbres',
        title   : 'Timbres',
        subtitle: 'Saldo, consumo y control operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:ticket',
        link    : '/admin/timbres'
    },
    {
        id      : 'movimientos',
        title   : 'Movimientos',
        subtitle: 'Recargas, ajustes y bitácora',
        type    : 'basic',
        icon    : 'heroicons_outline:arrows-right-left',
        link    : '/admin/movimientos'
    },
    {
        id      : 'soporte',
        title   : 'Soporte',
        subtitle: 'Seguimiento y apoyo operativo',
        type    : 'basic',
        icon    : 'heroicons_outline:lifebuoy',
        link    : '/admin/soporte'
    },
    {
        id      : 'configuracion',
        title   : 'Configuración',
        subtitle: 'Parámetros generales de la herramienta',
        type    : 'basic',
        icon    : 'heroicons_outline:cog-6-tooth',
        link    : '/admin/configuracion'
    }
];

export const horizontalNavigation_admin: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Inicio',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/admin/home'
    },
    {
        id: 'emitirFactura',
        title: 'Emitir factura',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/admin/emitirFactura'
    },
    {
        id: 'facturas',
        title: 'Facturas',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/admin/facturas'
    },
    {
        id: 'clientes',
        title: 'Clientes',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/admin/clientes'
    }
];

//menus para el responsable
export const defaultNavigation_responsable: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/responsable/home'
    },
    {
        id: 'nuevo-ticket',
        title: 'Nuevo ticket',
        type: 'basic',
        icon: 'heroicons_outline:plus-circle',
        link: '/responsable/nuevo-ticket'
    },
    {
        id: 'ticketsAbiertos',
        title: 'Mis tickets abiertos',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/responsable/tickets-abiertos'
    },
];
export const compactNavigation_responsable: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation_responsable: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation_responsable: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

//menus para el supervisor
export const defaultNavigation_cliente: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Inicio',
        subtitle: 'Resumen y actividad',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/cliente/home'
    },
    {
        id: 'emitirFactura',
        title: 'Emitir factura',
        subtitle: 'Crea y timbra CFDI 4.0',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/cliente/emitirFactura'
    },
    {
        id: 'razonesSociales',
        title: 'Perfil fiscal',
        subtitle: 'Razones sociales y configuración',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/cliente/perfil'
    },
    {
        id: 'clientes',
        title: 'Clientes',
        subtitle: 'Directorio de receptores',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/cliente/clientes'
    },
    {
        id: 'sucursales',
        title: 'Sucursales',
        subtitle: 'Series, folios y puntos de emisión',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/cliente/sucursales'
    },
    {
        id: 'facturas',
        title: 'Facturas',
        subtitle: 'CFDI emitidos',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/cliente/facturas'
    },
    {
        id: 'pagos',
        title: 'Pagos',
        subtitle: 'Complemento REP',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/cliente/pagos'
    },
    {
        id: 'facturacionMasivaGroup',
        title: 'Facturación masiva',
        subtitle: 'Excel y monitoreo',
        type: 'collapsable',
        icon: 'heroicons_outline:rectangle-stack',
        children: [
            {
                id: 'facturacionMasivaExcel',
                title: 'Carga por Excel',
                subtitle: 'Importar y timbrar en lote',
                type: 'basic',
                icon: 'heroicons_outline:arrow-up-tray',
                link: '/cliente/carga-masiva-excel'
            },
            {
                id: 'cargaMasivaMonitor',
                title: 'Monitor de procesos',
                subtitle: 'Estatus y reintentos',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/cliente/carga-masiva-monitor'
            }
        ]
    },
    {
        id: 'xmlValidador',
        title: 'Validación de XML',
        subtitle: 'EFOS / Art. 69 y estructura',
        type: 'basic',
        icon: 'heroicons_outline:document-magnifying-glass',
        link: '/cliente/xml-validador'
    },
];
export const compactNavigation_cliente: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation_cliente: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation_cliente: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example super',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

//-----------------
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
